import {
  useAssignSetting,
  useSetting,
} from "@faire/marketplace-lib/settings/__internal__/useSetting";
import { FE_RESUBSCRIBE_NUDGE_FOOTER_BANNER_250905 } from "@faire/retailer-settings/FE_RESUBSCRIBE_NUDGE_FOOTER_BANNER_250905";

export const useResubscribeNudgeFooterSetting = (): boolean => {
  return useSetting(FE_RESUBSCRIBE_NUDGE_FOOTER_BANNER_250905);
};

export const useAssignResubscribeNudgeFooterSetting = () => {
  return useAssignSetting(FE_RESUBSCRIBE_NUDGE_FOOTER_BANNER_250905);
};
